module.exports = __webpack_public_path__ + "img/xitong.757f5595.png";